import useStore from "@/shared/composition/useStore";
import useValores from "@/shared/composition/useValores";
import { router } from "@/shared/router";
import { ref, Ref, unref } from "@vue/composition-api";
import useContenido from "./useContenido";

export default function useListaContenidos(config: Ref<Record<string, any>>) {

    const currentItem = ref()
    const lastError = ref()
    const cargando = ref(false)
    const acumulado = ref()

    const getRespuesta = ({ respuesta }, data) => {

        const { nombre, path } = respuesta || {};

        if(!nombre){
            return {}
        }

        const { getValor } = useValores(data);
        
        return { [nombre]: path ? getValor(path) : data };
    };

    const cargar = async (fuente) => {

        acumulado.value = { ...fuente }
        cargando.value = true

        for (const item of config.value.items) {
            currentItem.value = config
            const { cargar: cargarItem, error, data } = useContenido(item as Record<string, any>)

            await cargarItem(acumulado.value)

            if (error.value) {
                lastError.value = error.value
                cargando.value = false
                return
            }

            const respuesta = getRespuesta(item, data.value);
            acumulado.value = { ...acumulado.value, ...respuesta }
        }

        lastError.value = null
        cargando.value = false
    }

    const guardarStore = () => {
        const { store: params } = unref(config)

        if(!params?.nombre){
            return
        }

        const { nombre, path } = params
        const { valor } = useStore(nombre)
        const { getValor } = useValores(acumulado.value)

        valor.value = getValor(path || nombre)
    }

    const redirect = () => {
        const { redirect } = unref(config)

        if(redirect){
            const { path, modelo } = redirect
            // cambiar argumento de useValores por Ref (para reutilizar)
            const { asignarDesdeObj } = useValores(acumulado.value)

            router.push({ path, query: asignarDesdeObj(modelo) })
        }  
    }

    const finalizar = () => {
        guardarStore()
        redirect()
    }

    return {
        currentItem,
        lastError,
        cargar,
        cargando,
        finalizar
    }
}